<template>
  <NavBar
    :title="title"
    left-arrow
	 fixed placeholder
    @click-left="onClickLeft"
    @click-right="onClickRight"
    :right-text="text"
  ></NavBar>
</template>

<script>
import { NavBar } from "vant";

export default {
  name: "navBar",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  components: {
    NavBar
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      this.$emit("onClickRight");
    }
  }
};
</script>

<style scoped>
.van-nav-bar__arrow {
  color: #212529;
}

.van-nav-bar__title {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(33, 37, 41, 1);
}
</style>
